import { Dispatch, SetStateAction } from 'react'
import { Form, Formik } from 'formik'
import { useSearchParams } from 'react-router-dom'

import { ExposePrivateKeyForm } from './expose-private-key-form.component'

import { codeVerificationSchema } from 'src/common/validations'
import { IUserPrivateKeyVerifyDto } from 'src/types'
import { EModalState } from './constants'

interface IExposePrivateKeyFormWrapperProps {
  exposePrivateKey: (val: string) => Promise<void>
  changeModalState: Dispatch<SetStateAction<EModalState>>
}

const ExposePrivateKeyFormWrapper = ({
  exposePrivateKey,
  changeModalState,
}: IExposePrivateKeyFormWrapperProps) => {
  const [searchParams] = useSearchParams()
  const handleSubmit = async (dto: IUserPrivateKeyVerifyDto) => {
    await exposePrivateKey(dto.code)
  }

  return (
    <Formik
      initialValues={{ code: searchParams.get('pk_code') || '' }}
      onSubmit={handleSubmit}
      validationSchema={codeVerificationSchema}
    >
      <Form>
        <ExposePrivateKeyForm changeModalState={changeModalState} />
      </Form>
    </Formik>
  )
}

export { ExposePrivateKeyFormWrapper }
